import { Localized } from 'dg-web-shared/lib/Localization.tsx';
import {
    ConfirmationDialog,
    ConfirmationDialogVersions,
} from './ConfirmationDialog.tsx';
import { useNavigate } from 'react-router-dom';

export function NoAccessDialogRoute() {
    const navigate = useNavigate();
    return <NoAccessDialog open onClose={() => navigate(-1)} />;
}

export function NoAccessDialog({
    open,
    onClose,
}: {
    open: boolean;
    onClose: () => void;
}) {
    return (
        <ConfirmationDialog
            open={open}
            confirmLabel={
                <Localized de="Schliessen" fr="Fermer" it="Chiudi" en="Close" />
            }
            onConfirm={onClose}
            title={
                <Localized
                    de="Fehlende Zugriffsrechte"
                    fr="Droits d'accès insuffisants"
                    it="Diritti d'accesso insufficienti"
                    en="Insufficient access rights"
                />
            }
            dialogVersion={ConfirmationDialogVersions.ERROR}
        >
            <>
                <p>
                    <Localized
                        de="Sie haben nicht die erforderlichen Zugriffsrechte, um die Details anzuzeigen."
                        fr="Vous n'avez pas les droits d'accès nécessaires pour voir les détails."
                        it="Non dispone dei diritti d’accesso necessari per visualizzare i dettagli."
                        en="You do not have the necessary access rights to view the details."
                    />
                </p>
                <p>
                    <Localized
                        de="Bitte wenden Sie sich an den Parkingportal-Administrator in Ihrem Unternehmen."
                        fr="Veuillez contacter l'administrateur Parkingportal de votre entreprise."
                        it="Contatti l’amministratore Parkingportal presso la sua azienda."
                        en="Please contact the Parkingportal administrator at your company."
                    />
                </p>
            </>
        </ConfirmationDialog>
    );
}
